import React from 'react';
import { ActionsContainer, RoundedButton } from '../styled';
import { RolloverStatusActionsProps } from '../types/RolloverStatusTypes';

const RolloverStatusActions: React.FC<RolloverStatusActionsProps> = ({
  onViewReport,
  onDownloadReport,
  viewLoading,
  downloadLoading
}) => {
  return (
    <ActionsContainer>
      <RoundedButton
        variant='contained'
        onClick={onViewReport}
        loading={viewLoading}
      >
        View Report
      </RoundedButton>
      <RoundedButton
        variant='contained'
        onClick={onDownloadReport}
        loading={downloadLoading}
      >
        Download Report
      </RoundedButton>
    </ActionsContainer>
  );
};

export default RolloverStatusActions;
